<template>
    <div v-for="(ticket, index) in product.Tickets" :key="ticket.Id" class="activity-tickets">
        <Ticket :ticket="ticket" :ticketNumber="index + 1" />
        <Divider
            v-if="index < product.Tickets.length - 1"
            color="lightGrey"
            bottomMargin="xxl"
            topMargin="xxl"
            thickness="1" />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { ActivityProduct } from '@/api/Cart/cart.interfaces';
    import { t } from '@shared/helpers/translation';
    import Ticket from './Ticket/Ticket.vue';
    import Divider from '@ui/components/Divider/Divider.vue';

    export default defineComponent({
        name: 'ActivityModalTickets',
        components: { Divider, Ticket },
        methods: { t },
        props: {
            product: {
                type: Object as PropType<ActivityProduct>,
                required: true,
            },
        },
    });
</script>
<style scoped lang="scss">
    @forward 'Tickets';
</style>
